(function () {
  /* ---- press feel for Add to cart + Buy it now (touch friendly) ---- */
  var SEL = '.add-to-cart-button, .ob-buynow';
  function btn(e) { return e.target && e.target.closest ? e.target.closest(SEL) : null; }
  function buzz(ms) { try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) {} }
  document.addEventListener('pointerdown', function (e) {
    var b = btn(e); if (!b || b.disabled) return;
    b.classList.remove('is-pop'); b.classList.add('is-press', 'is-sheen'); buzz(10);
  }, { passive: true });
  function release(e) {
    var b = btn(e) || document.querySelector('.is-press'); if (!b) return;
    document.querySelectorAll('.is-press').forEach(function (x) {
      x.classList.remove('is-press'); void x.offsetWidth; x.classList.add('is-pop');
      setTimeout(function () { x.classList.remove('is-pop', 'is-sheen'); }, 650);
    });
  }
  document.addEventListener('pointerup', release, { passive: true });
  document.addEventListener('pointercancel', release, { passive: true });
  document.addEventListener('pointerleave', release, true);

  /* ---- Buy it now: add the selected variant to the cart, then go to checkout ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ob-buynow]'); if (!b || b.dataset.busy) return;
    e.preventDefault();
    var form = b.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var id = form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
    var q = form && form.querySelector('[name="quantity"]'); var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
    var atc = form && form.querySelector('.add-to-cart-button');
    if (!id || (atc && atc.disabled)) return;
    b.dataset.busy = '1'; var label = b.querySelector('.ob-buynow__t'); if (label) label.textContent = 'Opening checkout...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +id, quantity: qty }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); b.classList.add('is-go'); setTimeout(function () { location.href = '/checkout'; }, 380); })
      .catch(function () { delete b.dataset.busy; if (label) label.textContent = 'Buy it now'; b.classList.remove('is-go'); });
  });

  /* Coming back from checkout (back button / bfcache) must not leave Buy it now stuck on "Opening checkout..." */
  function resetBuyNow() {
    document.querySelectorAll('[data-ob-buynow]').forEach(function (b) {
      delete b.dataset.busy; b.classList.remove('is-go', 'is-press', 'is-pop', 'is-sheen');
      var l = b.querySelector('.ob-buynow__t'); if (l) l.textContent = 'Buy it now';
    });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted || document.querySelector('[data-ob-buynow][data-busy]')) resetBuyNow(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && document.querySelector('[data-ob-buynow][data-busy]')) resetBuyNow(); });
})();
